import {gql} from '@apollo/client';

export const noteMutations = {
    CREATE_NOTE: gql`
        mutation CreateNode($input: NoteCreateEditRequestDTOInput!) {
            createNote(input: $input) {
                id
                title
                description
                createdDate
            }
        }
    `,
    UPDATE_NOTE: gql`
        mutation UpdateNote($id: UUID!, $input: NoteCreateEditRequestDTOInput!) {
            updateNote(id: $id, input: $input) {
                id
                title
                description
                createdDate
            }
        }
    `,
    REMOVE_NOTE: gql`
        mutation RemoveNote($noteId: UUID!) {
            removeNote(noteId: $noteId) {
                statusCode
                message
                data
            }
        }
    `,
};
